var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.5C4.986 20.5 0.5 16.014 0.5 10.5C0.5 4.986 4.986 0.5 10.5 0.5C16.014 0.5 20.5 4.986 20.5 10.5C20.5 16.014 16.014 20.5 10.5 20.5ZM10.5 2.5C6.089 2.5 2.5 6.089 2.5 10.5C2.5 14.911 6.089 18.5 10.5 18.5C14.911 18.5 18.5 14.911 18.5 10.5C18.5 6.089 14.911 2.5 10.5 2.5Z",
    fill: "#0FBC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4991 4.84244L9.49865 4.84315L9.49936 9.49944L4.84235 9.49944L4.84165 11.4998L9.49865 11.4998V16.1569L11.4991 16.1561L11.4998 11.4998L16.1554 11.4998L16.1561 9.49944L11.4991 9.49944L11.4991 4.84244Z",
    fill: "#0FBC71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/AddButton.475bf41bebff4e0fcf46a8c10220c464.svg";
export { ForwardRef as ReactComponent };